export default "__VITE_ASSET__DqflAIi8__"